const RX = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;

export default function WaText({ text = "" }) {
  return text.split(RX).map((part, i) => {
    if (part.length > 2) {
      const inner = part.slice(1, -1);
      if (part[0] === "*" && part.endsWith("*")) return <strong key={i}>{inner}</strong>;
      if (part[0] === "_" && part.endsWith("_")) return <em key={i}>{inner}</em>;
      if (part[0] === "~" && part.endsWith("~")) return <s key={i}>{inner}</s>;
    }
    return part;
  });
}
